

export const STORE_ID_KEY = "storeId";
export const COUNTRY_CODE_KEY = "countryCode";
